<div class="job-posts placements agreements top-link background-primary">
  <div class="card skillassest-form">



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-10px">
    <div class="row">
      <div class="col-md-3 padding-right-0px top-link">
        <div class="position-fixed-mis border-right2 padding-right-0px">
          <div class="card height-600px">

            <div class="card-header wh-header font-weight-normal padding-right-0px padding-bottom-0px padding-left-9px padding-top-5px background-new ">
              <!--<div class="row margin-top10px margin-left-20px card-title-schedule-bb">
            <div class="col-md-12">
              <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px ">
                MIS
              </label>
            </div>



          </div>-->

              <label class="margin-bottom-0px">MIS</label>

            </div>
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px background-new">
              <!--<div class="row border-top margin-left-0px margin-right-0px border-bottom-1px padding-bottom-3px">
            <div class="col-md-6 col-sm-4 padding-right-0px my-profile-form margin-left-5px padding-left-0px">
              <div class="date-form margin-top-5px form-group margin-bottom-0px">
                <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                       name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                <a (click)="d.toggle()" class="nav-link-hand">
                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                </a>

              </div>



            </div>
            <div class="col-md-1 " (click)="DecrementDate()">
              <a title="Previous" class="nav-link-hand">
                <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
              </a>
            </div>
            <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
              <a title="Next" class="nav-link-hand">
                <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
              </a>
            </div>
          </div>-->
              <div class="row padding-left-15px padding-right-15px">
                <div class="col-md-12">
                  <div class="accordion" id="Members">
                    <div class="card margin-bottom-5px ">
                      <div class="card-header wh-header border-all-0px  font-weight-normal label-table-color background-primary border-top-0px border-right-0  border-bottom-0px padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px" id="headingTwo">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                            <i class="fas fa-filter margin-left-15px margin-right-5px"></i> Select...
                          </button>
                        </h5>
                      </div>
                      <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#Members">
                        <div class="card-body padding-left-0px padding-top-0px padding-bottom-0px margin-left-0px padding-right-0px">
                          <div class="row" hidden>
                            <div class="col-md-8 display-inherit display-input margin-left-auto margin-right-auto">

                              <input type="radio" class="width-18px background-2 margin-top-6px">


                              <label class="margin-left-5px">Today [{{FromDate| date:'MMM-dd-yyyy'}}]</label>



                            </div>
                          </div>
                          <div class="row" hidden>
                            <div class="col-md-8 display-inherit display-input margin-left-auto margin-right-auto">

                              <input type="radio" class="width-18px background-2 margin-top-6px" [(ngModel)]="IsSelected" name="IsSelected">


                              <label class="margin-left-5px">Duration</label>



                            </div>
                          </div>
                          <div class="row  margin-left-0px margin-right-0px  padding-bottom-3px margin-top-10">
                            <div class="col-md-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px line-height-17px">
                              <label class="margin-bottom-0px font-size-12px color-Assign">Select Branch</label>
                              <div class="my-profile-form">


                                <CustomDataByRequestType RequestedType="FacilityList" class="form-group Strawfont" ActorCode={{ActorCode}}
                                                         (keyChange)="Roleassign($event)"
                                                         [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                                         required>
                                </CustomDataByRequestType>
                              </div>



                            </div>

                          </div>
                          <div class="row  margin-left-0px margin-right-0px  padding-bottom-3px margin-top-10">
                            <div class="col-md-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px line-height-17px">
                              <label class="margin-bottom-0px font-size-12px color-Assign">From</label>
                              <div class="date-form  form-group margin-bottom-0px">
                                <input class="form-control font-size-20px" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                       name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

                                <a (click)="d.toggle()" class="nav-link-hand">
                                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                </a>

                              </div>



                            </div>

                          </div>
                          <div class="row  margin-left-0px margin-right-0px margin-top-10  padding-bottom-3px">
                            <div class="col-md-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px  margin-top-12px">
                              <label class="margin-bottom-0px font-size-12px color-Assign">To</label>
                              <div class="date-form  form-group margin-bottom-0px">
                                <input class="form-control font-size-20px" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                       name="SelectedFromDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

                                <a (click)="d1.toggle()" class="nav-link-hand">
                                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                </a>

                              </div>



                            </div>

                          </div>
                          <div class="row  margin-left-0px margin-right-0px margin-top-10 padding-bottom-3px">
                            <div class="col-md-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px">

                              <button type="button" (click)="LoadNewDates()" class="btn font-size-13px actions-btn-prime margin-right-auto width-100pe">Set</button>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="chatsd product-chart-wrapper product-chat-width-mis agreement-chart-wrapper ps ps2  padding-top-10px padding-left-29px padding-right-29px padding-bottom-29px" data-ps-id="dfsfsde">

                <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand" (click)="SelectedGraphName(l)" *ngFor="let l of CurrentMisReportCategoriesController">
                  <!--<div class="col-md-3">
                <i class="fas fa-money-bill-alt"></i>
              </div>-->
                  <div class="col-md-12">

                    <a class="nav-link-hand margin-left-10px font-size-16px">{{l.ReportCategory}}</a>


                  </div>

                </div>
                <!--<div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand" (click)="Analysis()">
                  
                  <div class="col-md-12">

                    <a class="nav-link-hand margin-left-10px font-size-16px">Analysis</a>


                  </div>

                </div>-->
                <!--<div class="row border-bottom rowfor margin-left16px nav-link-hand" (click)="viewRow2()">
              <div class="col-md-12">

                <a class="nav-link-hand margin-left-5px">Followup</a>


              </div>

            </div>
            <div class="row border-bottom rowfor margin-left16px nav-link-hand" (click)="viewRow3()">
              <div class="col-md-12">

                <a class="nav-link-hand margin-left-5px">IVF</a>


              </div>

            </div>-->
              </div>

              <div>

              </div>

            </div>

          </div>
        </div>
      </div>


      <div class="col-md-9 col-12 margin-top-31px padding-left-0px" *ngIf="GraphDisplay">
        <!--<div class="card">
      <div class="card-body">-->
        <!--<div class="row" *ngIf="Row1">
      <div class="col-md-4 ">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <bargraph [ReportType]='ReportType'></bargraph>
          </div>
        </div>
      </div>

      <div class="col-md-4 ">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <doughnutgraph ReportType="Branchwise Collection"></doughnutgraph>
          </div>
        </div>
      </div>
      <div class="col-md-4 ">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <linegraph ReportType="Branchwise Refund"></linegraph>
          </div>
        </div>
      </div>
      <div class="col-md-4 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <piegraph [ReportType]='ReportType'></piegraph>
          </div>
        </div>
      </div>
      <div class="col-md-4 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <polarareagraph [ReportType]='ReportType'></polarareagraph>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="Row2">
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <linegraph></linegraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <polarareagraph></polarareagraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <piegraph></piegraph>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="Row3">
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <piegraph></piegraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <bargraph></bargraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <linegraph></linegraph>
          </div>
        </div>
      </div>
    </div>-->
        <!--<label>MIS: {{CanLoadReport}}</label>-->
        <xycharts [ReportCategory]='SelectedGarph.ReportCategory' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='SelectedFacilityCode' [FacilityName]='SelectedFacilityName'
                  [CanLoadReport]='CanLoadReport'></xycharts>
        <!--</div>
    </div>-->
        <!--<canvas id="barChart"></canvas>-->




      </div>
      <div class="col-md-9 col-12 margin-top-31px padding-left-0px" *ngIf="AnalysisDisplay">
        <!--<div class="card">
      <div class="card-body">-->
        <!--<div class="row" *ngIf="Row1">
      <div class="col-md-4 ">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <bargraph [ReportType]='ReportType'></bargraph>
          </div>
        </div>
      </div>

      <div class="col-md-4 ">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <doughnutgraph ReportType="Branchwise Collection"></doughnutgraph>
          </div>
        </div>
      </div>
      <div class="col-md-4 ">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <linegraph ReportType="Branchwise Refund"></linegraph>
          </div>
        </div>
      </div>
      <div class="col-md-4 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <piegraph [ReportType]='ReportType'></piegraph>
          </div>
        </div>
      </div>
      <div class="col-md-4 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <polarareagraph [ReportType]='ReportType'></polarareagraph>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="Row2">
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <linegraph></linegraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <polarareagraph></polarareagraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <piegraph></piegraph>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="Row3">
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <piegraph></piegraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <bargraph></bargraph>
          </div>
        </div>
      </div>
      <div class="col-md-3 margin-left-10px">
        <div class="card">
          <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">
            <linegraph></linegraph>
          </div>
        </div>
      </div>
    </div>-->
        <!--<label>MIS: {{CanLoadReport}}</label>-->
        <analysischarts  [FromDate]='FromDate' [ToDate]='ToDate'
                  [CanLoadReport]='CanLoadReport'></analysischarts>
        <!--</div>
    </div>-->
        <!--<canvas id="barChart"></canvas>-->




      </div>

    </div>
  </div>

</div>
<div class="job-posts placements margin-top-17px agreements top-link2">


  <div class="row" *ngIf="GraphList">
    <div class="col-md-2 col-12 padding-right-0px ">
      <div class="position-fixed-mis-sm border-right2 padding-right-0px">
        <div class="card">
          <div class="card-header wh-header font-weight-normal padding-right-0px padding-bottom-0px padding-left-9px padding-top-5px background-new ">
            <!--<div class="row margin-top10px margin-left-20px card-title-schedule-bb">
              <div class="col-md-10 col-10">
                <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                  MIS
                </label>
              </div>



            </div>-->
            <label class="margin-bottom-0px">MIS</label>


          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px background-new">
            <!--<div class="row border-top margin-left-0px margin-right-0px border-bottom-1px padding-bottom-3px">
              <div class="col-md-5 col-5 col-sm-4 padding-right-0px my-profile-form margin-left-sm-6px">
                <div class="date-form margin-top-5px form-group margin-bottom-0px">
                  <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>



              </div>
              <div class="col-md-1 col-1" (click)="DecrementDate()">
                <a title="Previous" class="nav-link-hand">
                  <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                </a>
              </div>
              <div class="col-md-1 col-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                <a title="Next" class="nav-link-hand">
                  <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                </a>
              </div>
            </div>-->

            <div class="row padding-left-15px padding-right-15px">
              <div class="col-md-12 col-12">
                <div class="accordion" id="Members2" hidden>
                  <div class="card margin-bottom-5px ">
                    <div class="card-header wh-header border-all-0px  font-weight-normal label-table-color background-primary border-top-0px border-right-0  border-bottom-0px padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px" id="headingThree">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                          <i class="fas fa-filter margin-left-15px margin-right-5px"></i> Select...
                        </button>
                      </h5>
                    </div>
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingThree" data-parent="#Members2">
                      <div class="card-body padding-left-0px padding-top-0px padding-bottom-0px margin-left-0px padding-right-0px">
                        <div class="row" hidden>
                          <div class="col-md-8 col-8 display-inherit display-input margin-left-auto margin-right-auto">

                            <input type="radio" class="width-18px background-2 margin-top-6px">


                            <label class="margin-left-5px">Today [{{FromDate| date:'MMM-dd-yyyy'}}]</label>



                          </div>
                        </div>
                        <div class="row" hidden>
                          <div class="col-md-8 display-inherit display-input margin-left-auto margin-right-auto">

                            <input type="radio" class="width-18px background-2 margin-top-6px" [(ngModel)]="IsSelected" name="IsSelected">


                            <label class="margin-left-5px">Duration</label>



                          </div>
                        </div>
                        
                        <div class="row  margin-left-0px margin-right-0px  padding-bottom-3px margin-top-10">
                          <div class="col-md-6 col-sm-4 col-6 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px line-height-17px">
                            <label class="margin-bottom-0px font-size-12px">From</label>
                            <div class="date-form  form-group margin-bottom-0px">
                              <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>



                          </div>

                        </div>
                        <div class="row  margin-left-0px margin-right-0px margin-top-10  padding-bottom-3px">
                          <div class="col-md-6 col-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px  margin-top-12px">
                            <label class="margin-bottom-0px font-size-12px">To</label>
                            <div class="date-form  form-group margin-bottom-0px">
                              <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="SelectedFromDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>



                          </div>

                        </div>
                        <div class="row  margin-left-0px margin-right-0px margin-top-10 padding-bottom-3px">
                          <div class="col-md-6 col-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px">

                            <button type="button" (click)="LoadNewDates()" class="btn font-size-13px actions-btn-prime margin-right-auto width-100pe">Set</button>

                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion" id="accordionExample">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">


                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          <i class="fas fa-filter margin-left-15px margin-right-5px"></i> Select...
                        </button>
                      </h5>





                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                      <div class="card-body padding-left-0px padding-top-0px padding-bottom-0px margin-left-0px padding-right-0px">
                        <div class="row  margin-left-0px margin-right-0px  padding-bottom-3px margin-top-10">
                          <div class="col-md-6 col-sm-4 col-6 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px line-height-17px">
                            <label class="margin-bottom-0px font-size-12px">Select Branch</label>
                            <div class="my-profile-form">


                              <CustomDataByRequestType RequestedType="FacilityList" class="form-group" ActorCode={{ActorCode}}
                                                       (keyChange)="Roleassign($event)"
                                                       [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode"
                                                       required>
                              </CustomDataByRequestType>
                            </div>



                          </div>

                        </div>

                        <div class="row  margin-left-0px margin-right-0px  padding-bottom-3px margin-top-10">
                          <div class="col-md-6 col-sm-4 col-6 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px line-height-17px">
                            <label class="margin-bottom-0px font-size-12px">From</label>
                            <div class="date-form  form-group margin-bottom-0px">
                              <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>



                          </div>

                        </div>
                        <div class="row  margin-left-0px margin-right-0px margin-top-10  padding-bottom-3px">
                          <div class="col-md-6 col-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px  margin-top-12px">
                            <label class="margin-bottom-0px font-size-12px">To</label>
                            <div class="date-form  form-group margin-bottom-0px">
                              <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="SelectedFromDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>



                          </div>

                        </div>
                        <div class="row  margin-left-0px margin-right-0px margin-top-10 padding-bottom-3px">
                          <div class="col-md-6 col-6 col-sm-4 padding-right-0px my-profile-form margin-left-auto margin-right-auto padding-left-3px">

                            <button type="button" (click)="LoadNewDates()" class="btn font-size-13px actions-btn-prime margin-right-auto width-100pe">Set</button>

                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="chatsd product-chart-wrapper product-chat-width-mis agreement-chart-wrapper ps ps2 padding-top-10px padding-left-29px padding-right-29px padding-bottom-29px  " data-ps-id="dfsfsde">
              <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" (click)="viewRow1Small(l)" *ngFor="let l of CurrentMisReportCategoriesController">
                <!--<div class="col-md-3">
                  <i class="fas fa-money-bill-alt"></i>
                </div>-->
                <div class="col-md-12 col-12">

                  <a class="nav-link-hand font-size-16px margin-left-5px">{{l.ReportCategory}}</a>


                </div>

              </div>
              <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" (click)="Analysis()">
                <!--<div class="col-md-3">
                  <i class="fas fa-money-bill-alt"></i>
                </div>-->
                <div class="col-md-12 col-12">

                  <a class="nav-link-hand font-size-16px margin-left-5px">Analysis</a>


                </div>

              </div>
            </div>

            <div>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="GraphData">

    <div class="col-md-10 col-12  padding-right-0px padding-left-5px">
      <div class="card">
        <div class="card-header wh-header font-weight-normal padding-right-0px padding-bottom-0px padding-left-9px padding-top-5px background-new ">
          <!--<div class="row margin-top10px margin-left-20px card-title-schedule-bb">
            <div class="col-md-10 col-10">
              <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                MIS
              </label>
            </div>


            <div class="col-md-1 col-1">
              <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
            </div>
          </div>-->
          <div class="row">
            <div class="col-10">
              <label class="margin-bottom-0px">MIS</label>
            </div>
            <div class="col-1">
              <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
            </div>
          </div>



        </div>
        <div class="card-body padding-right-0px padding-top-0px">

          <xycharts [ReportCategory]='SelectedGarphsmall.ReportCategory' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='SelectedFacilityCode'
                    [CanLoadReport]='CanLoadReport'></xycharts>





        </div>
      </div>


      <!--<canvas id="barChart"></canvas>-->




    </div>


  </div>
  <div class="row" *ngIf="Analysissmall">

    <div class="col-md-10 col-12  padding-right-0px padding-left-5px">
      <div class="card">
        <div class="card-header wh-header font-weight-normal padding-right-0px padding-bottom-0px padding-left-9px padding-top-5px background-new ">
          <!--<div class="row margin-top10px margin-left-20px card-title-schedule-bb">
            <div class="col-md-10 col-10">
              <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                MIS
              </label>
            </div>


            <div class="col-md-1 col-1">
              <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
            </div>
          </div>-->
          <div class="row">
            <div class="col-10">
              <label class="margin-bottom-0px">MIS</label>
            </div>
            <div class="col-1">
              <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
            </div>
          </div>



        </div>
        <div class="card-body padding-right-0px padding-top-0px">


          <analysischarts [FromDate]='FromDate' [ToDate]='ToDate'
                          [CanLoadReport]='CanLoadReport' *ngIf="AnalysisDisplay"></analysischarts>



        </div>
      </div>


      <!--<canvas id="barChart"></canvas>-->




    </div>


  </div>
</div>



<!--<div class="row top-link2 margin-top-30px">
  <div class="collapse" id="myCollapsible">
    <div class="card card-body">
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
    </div>
  </div>
  <button class="btn btn-primary " type="button" data-toggle="collapse" data-target="#myCollapsible" aria-expanded="false" aria-controls="collapseExample">
    Button with data-target
  </button>






</div>-->
